import { render, staticRenderFns } from "./CourseEnrollModal.vue?vue&type=template&id=08b2e7c4&"
import script from "./CourseEnrollModal.vue?vue&type=script&lang=js&"
export * from "./CourseEnrollModal.vue?vue&type=script&lang=js&"
import style0 from "./CourseEnrollModal.vue?vue&type=style&index=0&id=08b2e7c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports